export function getDashboardBasePath(role?: string | null) {
  return role === "super_admin" ? "/super_admin/dashboard" : "/admin/dashboard";
}

export function mapDashboardPath(pathname: string, role?: string | null) {
  const targetBase = getDashboardBasePath(role);
  if (pathname.startsWith("/admin/dashboard")) {
    return pathname.replace("/admin/dashboard", targetBase);
  }
  if (pathname.startsWith("/super_admin/dashboard")) {
    return pathname.replace("/super_admin/dashboard", targetBase);
  }
  return targetBase;
}
